<template>
  <!-- 字典，树结构 -->
  <separate-page :show-border="true" :show-shadow="false">
    <template #category>
      <el-tree ref="groupTree" node-key="id" :data="treeList" :current-node-key="parentData.id"
               :props="{ children: 'children', label: 'dictName' }" @node-click="clickDictionary" default-expand-all
               :expand-on-click-node="false">
        <template v-slot="{ node, data }">
            <span :class="parentData.id === data.id? 'custom-tree-node on': 'custom-tree-node'">
              <span class="node-name">{{ node.label }}</span>
              <span class="node-option">
              </span>
            </span>
        </template>
      </el-tree>
    </template>
    <template #default>
      <form-page :show-page="false" :show-border="false">
        <page-button hasPerm="sys:dict:remove" el-type="danger" type="delete" @click="toDelete" message="是否确认删除这个字典" :disabled="!currentData.id || !editAble">删除</page-button>
        <page-button hasPerm="sys:dict:add" el-type="success" type="write" @click="toEditData({})" :disabled="!editAble">新建</page-button>
        <page-button hasPerm="sys:dict:save" el-type="primary" type="write" @click="saveData" :disabled="!editAble">保存</page-button>
      </form-page>
      <el-form label-width="2.4rem">
        <el-form-item label="字典名称">
          <el-input v-model="currentData.dictName" placeholder="请输入字典名称"/>
        </el-form-item>
        <el-form-item label="字典编码" >
          <el-input v-model="currentData.userCode" placeholder="请输入字典编码"/>
        </el-form-item>
        <el-form-item label="上级分类">
          <el-tree-select :disabled="currentData.id" v-model="currentData.parentId" :data="treeList" clearable default-expand-all check-strictly :render-after-expand="false" placeholder="请选择上级" :props="{children: 'children', label: 'dictName'}" node-key="id"/>
        </el-form-item>
        <el-form-item label="图片"  v-if="dictionSetting.imageType === 1">
          <image-upload v-model="currentData.imageBackground" :limit="1" :upload-tips="`图片尺寸：${dictionSetting.imageSize}`" folder="dictionary"/>
        </el-form-item>
        <el-form-item label="详情图片" v-if="dictionSetting.imageType === 1">
          <image-upload v-model="currentData.imageInfront" :limit="3" folder="dictionary"/>
        </el-form-item>
      </el-form>
    </template>
  </separate-page>
</template>

<script>
import dictionaryApi from "@/api/normal/sys/dictionaryApi";
import PageButton from "@/components/h5/button/PageButton";
import ImageUpload from "@/components/h5/image/ImageUpload";
import SeparatePage from "@/components/h5/layout/SeparatorPage.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import util from "@/util/util";
export default {
  props: {
    dictionSetting: {
      default: () => {
        return {
          dictCode: "",
          dictName: "",
          imageType: 0,
          imageBackground: "",
          imageInfront: "",
          // 0:不可编辑，1:可编辑
          editAble: 0,
          uniqueType: 0, // 唯一性，普通字典和唯一字典不一样
        }
      }
    }
  },
  name: "",
  components: {
    PageButton, ImageUpload, SeparatePage, FormPage
  },
  data() {
    return {
      treeList: [],
      currentData: {
        userCode: "",
      },
      parentData: {},
      editAble: true,
      userInfo: {},
    };
  },
  created() {
    util.getUserInfo().then(user => {
      this.userInfo = user;
      if (this.dictionSetting.editAble === 0) {
        // 不可编辑，此时查询平台配置的信息
        this.editAble = user.merchantType === 1;
      }
      this.init();
    })

  },
  methods: {
    init() {
      if (this.dictionSetting.uniqueType === 1) { // 唯一字典
        dictionaryApi.queryUniqueTree(this.dictionSetting.dictCode).then(list => {
          this.treeList = list;
          this.currentData = {};
        });
      } else {
        if (this.dictionSetting.editAble === 0) {// 不可编辑字典
          dictionaryApi.queryParentTree(this.dictionSetting.dictCode).then(list => {
            this.treeList = list;
            this.currentData = {};
          });
        } else {
          dictionaryApi.queryListAsTree(this.dictionSetting.dictCode).then(list => {
            this.treeList = list;
            this.currentData = {};
          });
        }

      }

    },
    // 选中某个节点
    clickDictionary(data) {
      this.currentData = {...data};
      this.parentData = {...data};
    },
    toEditData(data) {
      if (data.id) {
        // 这个字典已存在
        this.currentData = {...data};
      } else {
        this.currentData = {
          ...data,
          parentId: this.parentData.id
        };
      }
    },
    saveData() {
      // 唯一字典
      if (this.dictionSetting.uniqueType === 1) {
        dictionaryApi.saveUniqueTreeNode({
          ...this.currentData,
          type: this.dictionSetting.dictCode
        }).then(() => {
          this.init();
        });
      } else {
        dictionaryApi.saveTreeNode({
          ...this.currentData,
          type: this.dictionSetting.dictCode
        }).then(() => {
          this.init();
        });
      }

    },
    toDelete() {
      if (this.currentData && this.currentData.id) {
        if (this.dictionSetting.uniqueType === 1) { // 唯一字典
          dictionaryApi.deleteUnique(this.dictionSetting.dictCode, this.currentData.id).then(() => {
            this.init();
          })
        } else {
          dictionaryApi.deleteById(this.currentData.id).then(() => {
            this.init();
          })
        }

      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/el-tree";
.menu-content{
  padding: 10px;
  box-sizing: border-box;
}
</style>